/**
 * ETAP 7 – helpers for the English version served under the /en/ URL prefix.
 * Polish stays at the root path, English mirrors the same slugs under /en/.
 */
import { useLocation } from "react-router-dom";

export const EN_PREFIX = "/en";

/** Removes the /en prefix from a pathname, always returning the Polish (canonical) path. */
export const stripEnPrefix = (pathname: string) => {
  if (pathname === EN_PREFIX || pathname === `${EN_PREFIX}/`) return "/";
  if (pathname.startsWith(`${EN_PREFIX}/`)) return pathname.slice(EN_PREFIX.length);
  return pathname;
};

/** Adds the /en prefix to a Polish path. */
export const withEnPrefix = (pathname: string) => {
  const base = stripEnPrefix(pathname);
  return base === "/" ? `${EN_PREFIX}/` : `${EN_PREFIX}${base}`;
};

export const isEnPath = (pathname: string) =>
  pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`);

/** true when the current URL is the English version. */
export const useIsEnglish = () => isEnPath(useLocation().pathname);

/** Prefixes an internal link when the English version is active. */
export const useLocalizedPath = () => {
  const isEn = useIsEnglish();
  return (path: string) => (isEn && path.startsWith("/") ? withEnPrefix(path) : path);
};
